export class ClickOnItemForTrade {
  static readonly type = '[Participation panel] Click on item in panel';
  constructor(readonly id: number) {}
}
